import { render, staticRenderFns } from "./MatrixChart.vue?vue&type=template&id=ee3b2aa0&scoped=true&"
import script from "./MatrixChart.vue?vue&type=script&lang=js&"
export * from "./MatrixChart.vue?vue&type=script&lang=js&"
import style0 from "./MatrixChart.vue?vue&type=style&index=0&id=ee3b2aa0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee3b2aa0",
  null
  
)

export default component.exports